module.exports = __webpack_public_path__ + "static/02-4ee6406a3b228063628fda8ac8f81d48.jpg";